<app-nav></app-nav>
<div class="container-fluid">
  <router-outlet></router-outlet>
</div>
